import React from 'react';
import Component from '@vfuk/core-match-media';
const MatchMedia = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default MatchMedia;
